import React, { useContext } from "react";
import { DayUseContext } from "../../../../context/DayUseContext";

import styles from "./styles/BasketDetailsView.module.scss";
import Heading from "../../../../shared/Heading/Heading";
import DayUseBasketCard from "../SectionComponents/DayUseBasketCard";
import InformationalBox from "../../../../shared/Containers/InformationalBox";
import Button from "../../../../shared/Button/Button";
import BLParagraph from "../../../../shared/Ionic/Paragraph/BLParagraph";

const BasketDetailsView = ({ isDesktop }) => {
  const {
    setView,
    dayUseTexts,
    refreshSearchParams,
    dayUseSelections,
    setDayUseSelections,
    handleEditAction,
  } = useContext(DayUseContext);
  return (
    <>
      <Heading
        txt={"Your reservation basket"}
        new_styles={{
          paddingBottom: "24px",
          textAlign: "center",
          font: "normal normal bold 26px/28px Crimson Pro",
          color: "#545E88",
        }}
      />

      {dayUseSelections.length > 0 ? (
        <div>
          {dayUseSelections?.map((sel, index) => (
            <DayUseBasketCard
              key={index}
              selection={sel}
              index={index}
              setSelections={setDayUseSelections}
              handleEditAction={handleEditAction}
              isDesktop={isDesktop}
            />
          ))}
          <div style={{ textAlign: "center", marginBottom: 16 }}>
            <BLParagraph 
              txt={dayUseTexts?.Paragraph_AdultOnlyDisclaimer1} 
              markDown  
            />
          </div>
          <div className={styles.day_use_basket_details_btns_wrapper}>
            <p
              style={{
                color: "#699DB0",
                font: "normal normal 600 18px/22px Open Sans",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => refreshSearchParams("show-activities")}
            >
              {"Add more experiences"}
            </p>

            <Button
              txt={"Reserve now"}
              onClick={() => setView({ type: "registration-view-form" })}
              backgroundColor={"#699DB0"}
              newStyles={{ border: "none" }}
            />
          </div>
        </div>
      ) : (
        <div className={styles.day_use_empty_basket_wrapper}>
          <InformationalBox
            content={`Your reservation basket is currently empty!`}
            boxNewStyles={{ width: "100%", justifyContent: "center" }}
          />
          <div style={{ paddingTop: "20px" }}>
            <Button
              txt={"Add more experiences"}
              onClick={() => refreshSearchParams("show-activities")}
              backgroundColor={"#699DB0"}
              newStyles={{ border: "none" }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BasketDetailsView;
